export const GET_ALL_PRODUCTS_REQUEST = "GET_ALL_PRODUCTS_REQUEST";
export const GET_ALL_PRODUCTS_SUCCESS = "GET_ALL_PRODUCTS_SUCCESS";
export const GET_ALL_PRODUCTS_FAIL = "GET_ALL_PRODUCTS_FAIL";

export const GET_ALL_CATEGORY_REQUEST = "GET_ALL_CATEGORY_REQUEST";
export const GET_ALL_CATEGORY_SUCCESS = "GET_ALL_CATEGORY_SUCCESS";
export const GET_ALL_CATEGORY_FAIL = "GET_ALL_CATEGORY_FAIL";

export const GET_PRODUCT_DETAILS_REQUEST = "GET_PRODUCT_DETAILS_REQUEST";
export const GET_PRODUCT_DETAILS_SUCCESS = "GET_PRODUCT_DETAILS_SUCCESS";
export const GET_PRODUCT_DETAILS_FAIL = "GET_PRODUCT_DETAILS_FAIL";

export const GET_PRODUCT_RATING_REQUEST = "GET_PRODUCT_RATING_REQUEST";
export const GET_PRODUCT_RATING_SUCCESS = "GET_PRODUCT_RATING_SUCCESS";
export const GET_PRODUCT_RATING_FAIL = "GET_PRODUCT_RATING_FAIL";

export const GIVE_RATING_REQUEST = "GIVE_RATING_REQUEST";
export const GIVE_RATING_SUCCESS = "GIVE_RATING_SUCCESS";
export const GIVE_RATING_FAIL = "GIVE_RATING_FAIL";

export const DELETE_RATING_REQUEST = "DELETE_RATING_REQUEST";
export const DELETE_RATING_SUCCESS = "DELETE_RATING_SUCCESS";
export const DELETE_RATING_FAIL = "DELETE_RATING_FAIL";


export const CLEAR_PRODUCT_ERRORS = "CLEAR_PRODUCT_ERRORS";
export const CLEAR_PRODUCT_STATE = "CLEAR_PRODUCT_STATE";

export const CLEAR_RATING_STATE = "CLEAR_RATING_STATE";
export const CLEAR_RATING_ERRORS = "CLEAR_RATING_ERRORS";
export const CLEAR_DELETE_RATING_STATE = "CLEAR_DELETE_RATING_STATE";


